import ColorScheme from '../ColorScheme/ColorScheme';

const ListThemes = {
    Light: {
        background: 'sf-white',
        backgroundHover: 'sf-gray-50',
        backgroundSelected: 'sf-primary-100',
        backgroundDisabled: 'sf-white',
        color: 'sf-gray-800',
        descColor: 'sf-gray-500',
        colorSelected: 'sf-primary-500',
        colorDisabled: 'sf-gray-400',
        icon: ColorScheme['sf-gray-500'],
        iconDisabled: ColorScheme['sf-gray-300'],
        iconSelected: ColorScheme['sf-primary-300']
    },

    Dark: {
        background: 'sf-gray-900',
        backgroundHover: 'sf-gray-800',
        backgroundSelected: 'sf-gray-1000',
        backgroundDisabled: 'sf-gray-900',
        color: 'sf-white',
        descColor: 'sf-gray-400',
        colorSelected: 'sf-primary-500',
        colorDisabled: 'sf-gray-400',
        icon: ColorScheme['sf-gray-500'],
        iconDisabled: ColorScheme['sf-gray-300'],
        iconSelected: ColorScheme['sf-primary-300']
    }
};

export default ListThemes;
